















import { Component, Prop, Mixins } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import BlueprintsMixin from "../../mixins/http/BlueprintsMixin";
import { httpStore } from "@/store/typed";

@Component({ components: { VSelect } })
export default class BlueprintSelect extends Mixins(BlueprintsMixin) {
  @Prop()
  readonly selected!: string | null;

  @Prop()
  readonly queryKey?: string;

  @Prop()
  readonly label?: string;

  @Prop()
  readonly placeholder?: string;

  @Prop({ default: false })
  readonly nullable: boolean;

  @Prop({ default: false })
  readonly preselect: boolean;

  @Prop({ default: false })
  readonly actsAsFilter: boolean;

  @Prop()
  readonly filter: any;

  @Prop({ default: false })
  readonly disabled: true;

  @Prop({
    default: () => {
      return "";
    },
  })
  readonly inputClass: string;

  options: VSelectOption[] = [];

  private value: string | null = this.selected || null;

  mounted() {
    this.loadItems();
  }

  get payload() {
    let data: any = {
      page: {
        size: "all",
      },
    };

    if (this.filter) {
      data.filter = this.filter;
    }

    return data;
  }

  get filterDefault() {
    return { id: "all", text: "All" };
  }

  get nullableDefault() {
    return { id: null, text: "None" };
  }

  get loading() {
    return httpStore.status[this.tag]?.loading;
  }

  get tag() {
    return `get_blueprint_tag`;
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);

    if (this.queryKey && this.$route.query[this.queryKey] !== this.value) {
      let query = this.$route.query;
      query[this.queryKey] = this.value;

      this.$router.push({ query });
    }
  }

  onItemsReady() {
    this.$emit("load");
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find((o) => o.id === this.selected)?.id;
    }
  }

  loadItems() {
    this.getBlueprints(this.payload, this.tag).then(
      (resp) => {
        this.options = resp.map((o) => {
          return { id: o.id, text: o.name };
        });
        if (this.actsAsFilter) {
          this.options.unshift(this.filterDefault);
        }
        if (this.nullable) {
          this.options.unshift(this.nullableDefault);
        }

        this.onItemsReady();
      },
      (err) => {}
    );
  }
}
